import moment from "moment/moment";
import { fetchWithAuth } from "../utils/fetch/FetchWithAuth";
import { prepareBaseGetListParams } from "../utils/fetch/PrepareBaseGetListParams";


export const MerchantService = {

    getList: (criteria) => {
        console.log('MerchantService::getList-criteria', criteria);
        const params = prepareBaseGetListParams(criteria);
        params.append('only_active', criteria.showOnlyActive || false);
        if (criteria.month) {
            params.append('month', moment(criteria.month).format('YYYY-MM'));
        }
        const url = `/portal/merchants?${params.toString()}`;
        return fetchWithAuth(url, { method: 'GET' });
    },
    getSimpleList: () => {
        return fetchWithAuth('/portal/merchants/simple-list', { method: 'GET' });
    },
    getStatusList: () => {
        return fetchWithAuth('/portal/merchants/status-list', { method: 'GET' });
    },

    getPrepaidStatusList: () => {
        return fetchWithAuth('/portal/merchants/prepaid-status-list', { method: 'GET' });
    }    
}